import { Fragment, useMemo } from 'react';
import { View } from 'react-native';
import StyleSheet from 'react-native-media-query';
import { Icon, useTheme } from '@ui-kitten/components';
import dayjs from 'dayjs';
import lodashIsEmpty from 'lodash/isEmpty';

import EmptyData from '../../Components/EmptyData';
import { textCategory } from '../../Components/Reservation/constants';
import ResponsiveText from '../../Components/ResponsiveText';
import ResponsiveLayout from '../../Components/ScreenWrapper/ResponsiveLayout';
import themeStyle from '../../Theme/styles';
import breakpoints from '../../Theme/styles/breakpoints';

import PageLoaderWeb from './PageLoaderWeb';
import ReservationDetails from './ReservationDetails';
import StyledTicketWeb from './StyledTicketWeb';
import useMyReservationDetails from './index.controller';

const ReservationConfirmation = (props) => {
  const theme = useTheme();
  const {
    data,
    isCheckoutSuccess,
    isError,
    isLoading,
    isReservation,
    isUninitialized,
  } = useMyReservationDetails(props);

  if (isLoading || isUninitialized) {
    return (
      <PageLoaderWeb
        isCheckoutSuccess={isCheckoutSuccess}
        isReservation={isReservation}
      />
    );
  } else if (isError) {
    return (
      <ResponsiveLayout
        LeftComponent={
          <View
            style={[themeStyle.flex1, themeStyle.flexDirectionRowCenterCenter]}
          >
            <EmptyData fill={theme['color-info-500']} type="filter" />
          </View>
        }
      />
    );
  } else if (lodashIsEmpty(data)) {
    return null;
  }

  return (
    <ResponsiveLayout
      LeftComponent={
        <View
          dataSet={{ media: ids.leftContentContainer }}
          style={[
            themeStyle.flex1,
            themeStyle.justifyContentCenter,
            styles.leftContentContainer,
          ]}
        >
          {isCheckoutSuccess && (
            <Fragment>
              <View style={styles.iconWrapper}>
                <Icon
                  name={'checkmark-circle-2-outline'}
                  pack={'eva'}
                  style={{ width: 50, height: 50 }}
                />
                <ResponsiveText category={textCategory.LARGE_HEADING}>
                  Thank you for booking with us
                </ResponsiveText>
              </View>

              <ResponsiveText
                category={textCategory.BODY}
                style={themeStyle.spacingBottom}
              >
                Thank you for booking with us! Your reservation
                {data?.store_details?.name
                  ? ` at ${data.store_details.name.toUpperCase()} `
                  : ' '}
                has been successfully confirmed. We're excited to welcome you
                and hope you have a great dining experience. Please review your
                booking details below.
              </ResponsiveText>
            </Fragment>
          )}
          <ResponsiveText
            category={textCategory.LARGE_HEADING}
            style={themeStyle.spacingBottom}
          >
            {isReservation ? 'Reservation' : 'Event'} Summary
          </ResponsiveText>
          <ReservationDetails data={data} />
        </View>
      }
      RightComponent={
        !isReservation && (
          <View
            dataSet={{ media: ids.ticketContainer }}
            style={styles.ticketContainer}
          >
            <StyledTicketWeb data={data} />
          </View>
        )
      }
    />
  );
};

const ticketTopOffset = -100; // offset scale size of ticket
export const { ids, styles } = StyleSheet.create({
  leftContentContainer: {
    [`@media ${breakpoints.lg}`]: {
      // large screen negative top margin
      marginTop: ticketTopOffset / 2,
    },
  },
  ticketContainer: {
    height: '100%',
    // negative margin offset the original scale height of ticket on mobile
    marginTop: -25,
    marginBottom: -175,
    [`@media ${breakpoints.lg}`]: {
      // no negative margin on 2 row display
      marginTop: ticketTopOffset / 4,
      marginBottom: ticketTopOffset,
    },
  },
  iconWrapper: {
    ...themeStyle.spacingBottom,
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'center',
    alignSelf: 'flex-start',
    gap: 5,
  },
});

export default ReservationConfirmation;
